export const aboutData = {
  brandName: "布丁漫画网",
  slogan: "甜蜜阅读，快乐每一天",
  introduction:
    "布丁漫画网成立于2023年，是国内领先的免费下拉式漫画阅读平台。我们致力于为漫画爱好者提供最优质的阅读体验，汇集了大量优秀的国产原创漫画和正版授权作品。",
  mission:
    "我们的使命是让每一个漫画爱好者都能随时随地免费享受高质量的漫画阅读体验。通过下拉式连续阅读技术，让读者沉浸在无缝的漫画世界中，不再被翻页打断阅读节奏。",
  story:
    "布丁漫画网的创始团队由一群热爱漫画的年轻人组成。我们深知等待翻页加载的痛苦，因此开发了下拉式连续阅读功能，让漫画阅读像丝滑般流畅。从最初只有几十部作品的小站，发展到如今拥有数千部精选漫画的知名平台，我们始终不忘初心——为读者提供最好的阅读体验。",
  features: [
    {
      title: "完全免费",
      description: "所有漫画免费阅读，无需付费订阅，让好内容触手可及",
      icon: "ri-money-cny-circle-line",
    },
    {
      title: "下拉畅读",
      description: "创新的下拉式连续阅读模式，无需频繁翻页，体验丝滑流畅",
      icon: "ri-scroll-to-bottom-line",
    },
    {
      title: "每日更新",
      description: "海量漫画每日更新，热门连载第一时间同步，追更不等待",
      icon: "ri-calendar-check-line",
    },
    {
      title: "高清画质",
      description: "所有漫画页面均采用高清画质呈现，每一个细节都清晰可见",
      icon: "ri-hd-line",
    },
    {
      title: "全平台适配",
      description: "完美适配电脑、平板和手机，随时随地畅享漫画阅读",
      icon: "ri-device-line",
    },
    {
      title: "智能推荐",
      description: "基于阅读偏好的智能推荐系统，帮你发现更多喜爱的漫画",
      icon: "ri-lightbulb-flash-line",
    },
  ],
  stats: [
    { label: "收录漫画", value: "5000+", icon: "ri-book-open-line" },
    { label: "每日活跃读者", value: "200万+", icon: "ri-user-heart-line" },
    { label: "累计阅读量", value: "10亿+", icon: "ri-eye-line" },
    { label: "用户好评率", value: "98.6%", icon: "ri-thumb-up-line" },
  ],
  testimonials: [
    {
      name: "漫画迷小王",
      avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20Chinese%20man%20with%20short%20black%20hair%20and%20glasses%20friendly%20smile%20clean%20simple%20illustration%20style%20warm%20peach%20background%20minimalist%20anime%20avatar%20flat%20color%20with%20soft%20shadows&width=120&height=120&seq=pudding-avatar-01&orientation=squarish",
      content: "布丁漫画的下拉式阅读真的太爽了！再也不用一页一页翻，直接往下滑就能连续看，体验丝滑到飞起。蜜桃少年超好看，画风超棒！",
      rating: 5,
    },
    {
      name: "追漫少女",
      avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20Chinese%20woman%20with%20long%20black%20hair%20and%20bright%20eyes%20warm%20smile%20clean%20simple%20illustration%20style%20soft%20pink%20background%20minimalist%20anime%20avatar%20flat%20color%20with%20gentle%20shadows&width=120&height=120&seq=pudding-avatar-02&orientation=squarish",
      content: "每天都在布丁漫画追更新，樱花恋歌太好看了！网站界面干净清爽，没有任何弹窗广告，阅读体验一级棒。强烈推荐！",
      rating: 5,
    },
    {
      name: "资深漫画控",
      avatar: "https://readdy.ai/api/search-image?query=Anime%20style%20portrait%20of%20a%20young%20Chinese%20man%20with%20stylish%20undercut%20haircut%20cool%20confident%20expression%20clean%20simple%20illustration%20style%20warm%20golden%20background%20minimalist%20anime%20avatar%20flat%20color%20with%20soft%20shadows&width=120&height=120&seq=pudding-avatar-03&orientation=squarish",
      content: "看了十几年漫画了，布丁漫画是我用过最好的免费漫画网站。分类齐全，更新快，画质高清。最重要的是——真的完全免费！",
      rating: 5,
    },
  ],
  contact: {
    email: "contact@puddingcomic.com",
    wechat: "布丁漫画官方",
    weibo: "@布丁漫画网",
    address: "上海市浦东新区张江高科技园区",
    phone: "400-888-6666",
  },
  faqs: [
    {
      question: "布丁漫画网的漫画真的完全免费吗？",
      answer: "是的，布丁漫画网的所有漫画内容均完全免费阅读，无需任何付费订阅。我们通过广告合作和版权授权来维持运营，确保读者始终能够免费享受优质的漫画内容。",
    },
    {
      question: "什么是下拉式阅读模式？",
      answer: "下拉式阅读是一种创新的漫画阅读方式，读者只需向下滑动页面即可连续阅读整本漫画，无需频繁点击翻页按钮。这种方式让阅读体验更加流畅自然，不会打断阅读节奏。",
    },
    {
      question: "布丁漫画网的更新频率是怎样的？",
      answer: "我们与众多漫画作者和出版社保持紧密合作，热门连载漫画通常保持每周更新的节奏。首页每日更新最新上架的漫画，确保读者能够第一时间看到新鲜内容。",
    },
    {
      question: "如何在手机上阅读布丁漫画？",
      answer: "布丁漫画网采用响应式设计，完美适配手机、平板和电脑等各种设备。您只需要在手机浏览器中打开我们的网站，即可享受与电脑端同样流畅的下拉式阅读体验。",
    },
    {
      question: "布丁漫画网的漫画是否有版权？",
      answer: "是的，布丁漫画网高度重视版权保护。平台上所有漫画均经过正版授权或与原作者合作，确保每一位创作者都能得到应有的回报。我们坚决支持正版漫画，反对盗版行为。",
    },
  ],
};